/* eslint-disable sort-keys-fix/sort-keys-fix -- CSS-in-JS pseudo-selector keys use semantic ordering */
// MUI v4 TextField multiline-variant, NS/Tractie textarea-pendant overrides.
// Tractie source: textarea.
// Tractie textarea key-verschillen vs input: padding-inline-end ruimer voor
// resize-handle area (40px), min-height 4lh. MUI TextField heeft alleen `root`
// als classKey; mode-split via attribuut-selector in root.
// Mode-split: Dark spread Light.

export const MuiTextFieldMultilineLightOverrides = {
  root: {
    '& textarea': {
      paddingInlineEnd: 'var(--ns-space-10)',
      minHeight: 'calc(4 * var(--ns-font-leading-l) * 1em)',
      resize: 'vertical' as const,
      boxSizing: 'border-box' as const,
      width: '100%',
    },
  },
} as const;

export const MuiTextFieldMultilineDarkOverrides = {
  ...MuiTextFieldMultilineLightOverrides,
} as const;
